import { render, staticRenderFns } from "./Avoir.vue?vue&type=template&id=d2be5dd8"
import script from "./Avoir.vue?vue&type=script&lang=js"
export * from "./Avoir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports